import React from "react";
import styles from "./../../sass/landing/footer.module.scss";
import classNames from "classnames";
import {
  facebook,
  twitter,
  linkedin,
  telegram,
  instagram
} from './../assets/icons/social/';

const Footer = (props) => {
  return (
    <div style={{background:"#121927"}}>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className={classNames(styles["footer"])}>
              <div className="row">
                <div className={classNames(styles["legal"],"col-md-6 col-12")}>
                  <div className="mb-1">
                    Bluesphere Carbon &mdash; <a href="/tos">ToS</a>
                  </div>
                  All rights reserved &copy; {new Date().getFullYear()}
                </div>
                <div className={classNames(styles["social"],"col-md-6 col-12 align-items-center d-flex justify-content-center justify-content-md-end mt-4 mt-md-0")}>
                  <a href="https://facebook.com/bluespherecarbon" target="_blank" className="me-3" rel="noreferrer">
                    <img src={facebook} className="facebook" alt="Facebook"/>
                  </a>
                  <a href="https://twitter.com/BluesphereHQ" target="_blank" className="me-3" rel="noreferrer">
                    <img src={twitter} className="twitter" alt="Twitter"/>
                  </a>
                </div>
              </div>  
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
